import { v4 as uuidv4 } from 'uuid';

export default function genererGuid() {
  return uuidv4();
}
